var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendfox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 105.2 22.1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11l9.8 8.8 9.7-8.8v11.1H0z",
    fill: "#ccdfed"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.9l9.8 8.9 9.7-8.9zm13.3-2.3h6.2V0zM0 0v5.6h6.2z",
    fill: "#ff644d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3 10c-2-.8-3.3-1.4-3.3-2.8 0-1.3 1.3-2.3 2.8-2.3s2.5.9 2.9 1.9l1.6-.6c-.6-1.7-2.4-2.9-4.5-2.9-2.2 0-4.6 1.5-4.6 3.9 0 2.6 2.5 3.6 4.4 4.4 2.1.8 3.3 1.5 3.3 2.9 0 1.6-1.1 2.7-2.9 2.7-1.9 0-3.2-1.3-3.6-2.6l-1.7.4c.5 1.9 2.5 3.8 5.2 3.8s4.7-1.8 4.7-4.4c.2-2.7-2.3-3.6-4.3-4.4zm15.5.8c0-1.7-1.5-3.4-4-3.4s-5.2 2.1-5.2 5.7c0 3.7 2.7 5.7 5.3 5.7.9 0 2.3-.2 3.7-1.1l-.9-1.4c-1 .7-2.1.9-2.8.9-1.5 0-2.9-1-3.3-2.6 3.3-.1 7.2-.6 7.2-3.8zm-7.3 2.3c0-2.5 1.8-4.1 3.4-4.1 1.3 0 2.2 1 2.2 1.8-.1 1.4-2 2.2-5.6 2.3zm15.3-5.7c-1.2 0-2.7.5-3.9 2.1v-2h-1.7v11.1H52v-6.2c.8-2.5 2.7-3.4 3.8-3.4 1.2 0 1.9.9 1.9 2.4v7.2h1.8v-7.2c0-2.9-1.9-4-3.7-4zm13.9 1.5c-.7-.9-1.8-1.5-3.1-1.5-2.8 0-4.9 2.4-4.9 5.7s2.1 5.7 4.9 5.7c1.4 0 2.5-.6 3.3-1.6v1.4h1.7V3.4h-1.8v5.5zm-3.1 8.3c-1.8 0-3.2-1.8-3.2-4.1S64.8 9 66.6 9c1.9 0 3.2 1.9 3.2 4.1s-1.3 4.1-3.2 4.1zm8.3 1.5h1.9V12h5.6v-1.6h-5.6V5.3h6.7V3.7h-8.6zM89.3 7.4c-2.8 0-4.9 2.4-4.9 5.7s2.1 5.7 4.9 5.7 4.9-2.4 4.9-5.7-2-5.7-4.9-5.7zm0 9.8c-1.8 0-3.1-1.8-3.1-4.1S87.5 9 89.3 9s3.1 1.8 3.1 4.1-1.2 4.1-3.1 4.1zm15.9 1.5l-4-5.7 3.8-5.4h-2.2l-2.6 3.9-2.7-3.9h-2.2l3.8 5.4-4 5.7h2.2l2.9-4.2 2.8 4.2z",
    fill: "#4c5366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendfox);
export default __webpack_public_path__ + "static/media/sendfox.34717b7dd63c51c9a7a329568e62c499.svg";
export { ForwardRef as ReactComponent };